export interface Currency {
  code: string;
  name: string;
  symbol: string;
}

/** ISO 4217 common currencies — sorted by code. */
export const CURRENCIES: Currency[] = [
  { code: 'AED', name: 'UAE Dirham',                      symbol: 'د.إ'  },
  { code: 'AFN', name: 'Afghan Afghani',                  symbol: '؋'   },
  { code: 'ALL', name: 'Albanian Lek',                    symbol: 'L'   },
  { code: 'AMD', name: 'Armenian Dram',                   symbol: '֏'   },
  { code: 'ARS', name: 'Argentine Peso',                  symbol: '$'   },
  { code: 'AUD', name: 'Australian Dollar',               symbol: 'A$'  },
  { code: 'AZN', name: 'Azerbaijani Manat',               symbol: '₼'   },
  { code: 'BAM', name: 'Bosnia-Herzegovina Convertible Mark', symbol: 'KM' },
  { code: 'BDT', name: 'Bangladeshi Taka',                symbol: '৳'   },
  { code: 'BGN', name: 'Bulgarian Lev',                   symbol: 'лв'  },
  { code: 'BHD', name: 'Bahraini Dinar',                  symbol: '.د.ب' },
  { code: 'BND', name: 'Brunei Dollar',                   symbol: 'B$'  },
  { code: 'BOB', name: 'Bolivian Boliviano',              symbol: 'Bs.' },
  { code: 'BRL', name: 'Brazilian Real',                  symbol: 'R$'  },
  { code: 'CAD', name: 'Canadian Dollar',                 symbol: 'C$'  },
  { code: 'CHF', name: 'Swiss Franc',                     symbol: 'Fr'  },
  { code: 'CLP', name: 'Chilean Peso',                    symbol: '$'   },
  { code: 'CNY', name: 'Chinese Yuan',                    symbol: '¥'   },
  { code: 'COP', name: 'Colombian Peso',                  symbol: '$'   },
  { code: 'CRC', name: 'Costa Rican Colón',               symbol: '₡'   },
  { code: 'CZK', name: 'Czech Koruna',                    symbol: 'Kč'  },
  { code: 'DKK', name: 'Danish Krone',                    symbol: 'kr'  },
  { code: 'DZD', name: 'Algerian Dinar',                  symbol: 'د.ج' },
  { code: 'EGP', name: 'Egyptian Pound',                  symbol: '£'   },
  { code: 'ETB', name: 'Ethiopian Birr',                  symbol: 'Br'  },
  { code: 'EUR', name: 'Euro',                            symbol: '€'   },
  { code: 'GBP', name: 'British Pound Sterling',          symbol: '£'   },
  { code: 'GEL', name: 'Georgian Lari',                   symbol: '₾'   },
  { code: 'GHS', name: 'Ghanaian Cedi',                   symbol: '₵'   },
  { code: 'GTQ', name: 'Guatemalan Quetzal',              symbol: 'Q'   },
  { code: 'HKD', name: 'Hong Kong Dollar',                symbol: 'HK$' },
  { code: 'HNL', name: 'Honduran Lempira',                symbol: 'L'   },
  { code: 'HUF', name: 'Hungarian Forint',                symbol: 'Ft'  },
  { code: 'IDR', name: 'Indonesian Rupiah',               symbol: 'Rp'  },
  { code: 'ILS', name: 'Israeli New Shekel',              symbol: '₪'   },
  { code: 'INR', name: 'Indian Rupee',                    symbol: '₹'   },
  { code: 'IQD', name: 'Iraqi Dinar',                     symbol: 'ع.د' },
  { code: 'IRR', name: 'Iranian Rial',                    symbol: '﷼'   },
  { code: 'ISK', name: 'Icelandic Króna',                 symbol: 'kr'  },
  { code: 'JMD', name: 'Jamaican Dollar',                 symbol: 'J$'  },
  { code: 'JOD', name: 'Jordanian Dinar',                 symbol: 'د.ا' },
  { code: 'JPY', name: 'Japanese Yen',                    symbol: '¥'   },
  { code: 'KES', name: 'Kenyan Shilling',                 symbol: 'KSh' },
  { code: 'KGS', name: 'Kyrgyzstani Som',                 symbol: 'с'   },
  { code: 'KHR', name: 'Cambodian Riel',                  symbol: '៛'   },
  { code: 'KRW', name: 'South Korean Won',                symbol: '₩'   },
  { code: 'KWD', name: 'Kuwaiti Dinar',                   symbol: 'د.ك' },
  { code: 'KZT', name: 'Kazakhstani Tenge',               symbol: '₸'   },
  { code: 'LBP', name: 'Lebanese Pound',                  symbol: 'ل.ل' },
  { code: 'LKR', name: 'Sri Lankan Rupee',                symbol: 'Rs'  },
  { code: 'LYD', name: 'Libyan Dinar',                    symbol: 'ل.د' },
  { code: 'MAD', name: 'Moroccan Dirham',                 symbol: 'د.م.' },
  { code: 'MDL', name: 'Moldovan Leu',                    symbol: 'L'   },
  { code: 'MKD', name: 'Macedonian Denar',                symbol: 'ден' },
  { code: 'MMK', name: 'Myanmar Kyat',                    symbol: 'K'   },
  { code: 'MXN', name: 'Mexican Peso',                    symbol: '$'   },
  { code: 'MYR', name: 'Malaysian Ringgit',               symbol: 'RM'  },
  { code: 'NGN', name: 'Nigerian Naira',                  symbol: '₦'   },
  { code: 'NOK', name: 'Norwegian Krone',                 symbol: 'kr'  },
  { code: 'NPR', name: 'Nepalese Rupee',                  symbol: 'Rs'  },
  { code: 'NZD', name: 'New Zealand Dollar',              symbol: 'NZ$' },
  { code: 'OMR', name: 'Omani Rial',                      symbol: 'ر.ع.' },
  { code: 'PAB', name: 'Panamanian Balboa',               symbol: 'B/.' },
  { code: 'PEN', name: 'Peruvian Sol',                    symbol: 'S/'  },
  { code: 'PHP', name: 'Philippine Peso',                 symbol: '₱'   },
  { code: 'PKR', name: 'Pakistani Rupee',                 symbol: '₨'   },
  { code: 'PLN', name: 'Polish Zloty',                    symbol: 'zł'  },
  { code: 'PYG', name: 'Paraguayan Guarani',              symbol: '₲'   },
  { code: 'QAR', name: 'Qatari Riyal',                    symbol: 'ر.ق' },
  { code: 'RON', name: 'Romanian Leu',                    symbol: 'lei' },
  { code: 'RSD', name: 'Serbian Dinar',                   symbol: 'din' },
  { code: 'RUB', name: 'Russian Ruble',                   symbol: '₽'   },
  { code: 'SAR', name: 'Saudi Riyal',                     symbol: 'ر.س' },
  { code: 'SEK', name: 'Swedish Krona',                   symbol: 'kr'  },
  { code: 'SGD', name: 'Singapore Dollar',                symbol: 'S$'  },
  { code: 'THB', name: 'Thai Baht',                       symbol: '฿'   },
  { code: 'TJS', name: 'Tajikistani Somoni',              symbol: 'SM'  },
  { code: 'TMT', name: 'Turkmenistani Manat',             symbol: 'T'   },
  { code: 'TND', name: 'Tunisian Dinar',                  symbol: 'د.ت' },
  { code: 'TRY', name: 'Turkish Lira',                    symbol: '₺'   },
  { code: 'TTD', name: 'Trinidad & Tobago Dollar',        symbol: 'TT$' },
  { code: 'TWD', name: 'New Taiwan Dollar',               symbol: 'NT$' },
  { code: 'TZS', name: 'Tanzanian Shilling',              symbol: 'TSh' },
  { code: 'UAH', name: 'Ukrainian Hryvnia',               symbol: '₴'   },
  { code: 'UGX', name: 'Ugandan Shilling',                symbol: 'USh' },
  { code: 'USD', name: 'US Dollar',                       symbol: '$'   },
  { code: 'UYU', name: 'Uruguayan Peso',                  symbol: '$U'  },
  { code: 'UZS', name: 'Uzbekistani Som',                 symbol: 'сум' },
  { code: 'VND', name: 'Vietnamese Dong',                 symbol: '₫'   },
  { code: 'XAF', name: 'Central African CFA Franc',       symbol: 'FCFA'},
  { code: 'XOF', name: 'West African CFA Franc',          symbol: 'CFA' },
  { code: 'YER', name: 'Yemeni Rial',                     symbol: '﷼'   },
  { code: 'ZAR', name: 'South African Rand',              symbol: 'R'   },
  { code: 'ZMW', name: 'Zambian Kwacha',                  symbol: 'ZK'  },
];

/** Format a currency for display in a dropdown option. */
export function formatCurrencyOption(c: Currency): string {
  return `${c.code} — ${c.name}`;
}

export const CURRENCY_OPTIONS = CURRENCIES.map(c => ({
  value: c.code,
  label: formatCurrencyOption(c),
}));
